// extracted by mini-css-extract-plugin
export default {"charSizeWarning":"CharSizeWarning_charSizeWarning__cU1xO"};